/* eslint-disable camelcase */
import { STRINGS } from '../../constants';
import { RegularService } from '../../models';
import { GET_REGULAR_SERVICES_FOR_TYPE } from '../constants/regularServicesForType';

const convertService = (service) => {
  const { id, name, typ, price, price_with_fee } = service;
  return new RegularService(id, name, typ, price, price_with_fee);
};

// eslint-disable-next-line import/prefer-default-export
export const getRegularServicesForType = (typ, regularServices) => {
  const convertedRegularServicesForType = Object.entries(STRINGS.REGULAR_SERVICES[typ]).map(
    (item) => {
      const key = item[0];
      const existingService = regularServices.find((item) => item.name === key);
      if (existingService) return convertService(existingService);
      return { name: key };
    },
  );

  return (dispatch) => {
    dispatch({
      type: GET_REGULAR_SERVICES_FOR_TYPE,
      regularServicesForType: convertedRegularServicesForType,
    });
  };
};
